export default __webpack_public_path__ + "assets/webgl/scene-5.6a46ff12.glb";